import Vue from 'vue'
import App from './App'
import router from './router'

import '@inkline/inkline/dist/inkline.css';
import Inkline from '@inkline/inkline';
import VCalendar from 'v-calendar';
import InklineValidation from '@inkline/inkline/dist/validation';
import {VLazyImagePlugin} from "v-lazy-image";
import VueAnalytics from 'vue-analytics';
import 'lazysizes';

Vue.use(Inkline);
Vue.use(VCalendar, {
    firstDayOfWeek: 2,
    formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: 'DD-MM-YYYY',
        dayPopover: 'DD-MM-YYYY',
        data: 'DD-MM-YYYY'
    }
});
Vue.use(InklineValidation);
Vue.use(VLazyImagePlugin);
Vue.use(VueAnalytics, {
    id: 'UA-141820884-1',
    router,
    autoTracking: {
        pageviewTemplate (route) {
            return {
                page: route.path,
                title: document.title,
                location: window.location.href
            }
        }
    }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue ({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});



// WEBPACK FOOTER //
// ./src/main.js